export enum CountryKeys {
  afghanistan = "afghanistan",
  aland_islands = "aland_islands",
  albania = "albania",
  algeria = "algeria",
  american_samoa = "american_samoa",
  andorra = "andorra",
  angola = "angola",
  anguilla = "anguilla",
  antarctica = "antarctica",
  antigua_barbuda = "antigua_barbuda",
  argentina = "argentina",
  armenia = "armenia",
  aruba = "aruba",
  australia = "australia",
  austria = "austria",
  azerbaijan = "azerbaijan",
  bahamas = "bahamas",
  bahrain = "bahrain",
  bangladesh = "bangladesh",
  barbados = "barbados",
  belarus = "belarus",
  belgium = "belgium",
  belize = "belize",
  benin = "benin",
  bermuda = "bermuda",
  bhutan = "bhutan",
  bolivia = "bolivia",
  bosnia_herzegovina = "bosnia_herzegovina",
  botswana = "botswana",
  bouvet_island = "bouvet_island",
  brazil = "brazil",
  british_indian_ocean_territory = "british_indian_ocean_territory",
  british_virgin_islands = "british_virgin_islands",
  brunei = "brunei",
  bulgaria = "bulgaria",
  burkina_faso = "burkina_faso",
  burundi = "burundi",
  cambodia = "cambodia",
  cameroon = "cameroon",
  canada = "canada",
  cape_verde = "cape_verde",
  bonaire_sint_eustatius_saba = "bonaire_sint_eustatius_saba",
  cayman_islands = "cayman_islands",
  central_african_republic = "central_african_republic",
  chad = "chad",
  chile = "chile",
  china = "china",
  christmas_island = "christmas_island",
  cocos_keeling_islands = "cocos_keeling_islands",
  colombia = "colombia",
  comoros = "comoros",
  cook_islands = "cook_islands",
  costa_rica = "costa_rica",
  cote_divoire = "cote_divoire",
  croatia = "croatia",
  cuba = "cuba",
  curacao = "curacao",
  cyprus = "cyprus",
  czechia = "czechia",
  denmark = "denmark",
  djibouti = "djibouti",
  dominica = "dominica",
  dominican_republic = "dominican_republic",
  dr_congo = "dr_congo",
  ecuador = "ecuador",
  egypt = "egypt",
  el_salvador = "el_salvador",
  equatorial_guinea = "equatorial_guinea",
  eritrea = "eritrea",
  estonia = "estonia",
  eswatini = "eswatini",
  ethiopia = "ethiopia",
  falkland_islands = "falkland_islands",
  faroe_islands = "faroe_islands",
  fiji = "fiji",
  finland = "finland",
  france = "france",
  french_guiana = "french_guiana",
  french_polynesia = "french_polynesia",
  french_southern_antarctic_lands = "french_southern_antarctic_lands",
  gabon = "gabon",
  gambia = "gambia",
  georgia = "georgia",
  germany = "germany",
  ghana = "ghana",
  gibraltar = "gibraltar",
  greece = "greece",
  greenland = "greenland",
  grenada = "grenada",
  guadeloupe = "guadeloupe",
  guam = "guam",
  guatemala = "guatemala",
  guernsey = "guernsey",
  guinea = "guinea",
  guinea_bissau = "guinea_bissau",
  guyana = "guyana",
  haiti = "haiti",
  heard_island_mcdonald_islands = "heard_island_mcdonald_islands",
  honduras = "honduras",
  hong_kong = "hong_kong",
  hungary = "hungary",
  iceland = "iceland",
  india = "india",
  indonesia = "indonesia",
  iran = "iran",
  iraq = "iraq",
  ireland = "ireland",
  isle_of_man = "isle_of_man",
  israel = "israel",
  italy = "italy",
  jamaica = "jamaica",
  japan = "japan",
  jersey = "jersey",
  jordan = "jordan",
  kazakhstan = "kazakhstan",
  kenya = "kenya",
  kiribati = "kiribati",
  kosovo = "kosovo",
  kuwait = "kuwait",
  kyrgyzstan = "kyrgyzstan",
  laos = "laos",
  latvia = "latvia",
  lebanon = "lebanon",
  lesotho = "lesotho",
  liberia = "liberia",
  libya = "libya",
  liechtenstein = "liechtenstein",
  lithuania = "lithuania",
  luxembourg = "luxembourg",
  macau = "macau",
  madagascar = "madagascar",
  malawi = "malawi",
  malaysia = "malaysia",
  maldives = "maldives",
  mali = "mali",
  malta = "malta",
  marshall_islands = "marshall_islands",
  martinique = "martinique",
  mauritania = "mauritania",
  mauritius = "mauritius",
  mayotte = "mayotte",
  mexico = "mexico",
  micronesia = "micronesia",
  moldova = "moldova",
  monaco = "monaco",
  mongolia = "mongolia",
  montenegro = "montenegro",
  montserrat = "montserrat",
  morocco = "morocco",
  mozambique = "mozambique",
  myanmar = "myanmar",
  namibia = "namibia",
  nauru = "nauru",
  nepal = "nepal",
  netherlands = "netherlands",
  new_caledonia = "new_caledonia",
  new_zealand = "new_zealand",
  nicaragua = "nicaragua",
  niger = "niger",
  nigeria = "nigeria",
  niue = "niue",
  norfolk_island = "norfolk_island",
  north_korea = "north_korea",
  north_macedonia = "north_macedonia",
  northern_mariana_islands = "northern_mariana_islands",
  norway = "norway",
  oman = "oman",
  pakistan = "pakistan",
  palau = "palau",
  palestine = "palestine",
  panama = "panama",
  papua_new_guinea = "papua_new_guinea",
  paraguay = "paraguay",
  peru = "peru",
  philippines = "philippines",
  pitcairn_islands = "pitcairn_islands",
  poland = "poland",
  portugal = "portugal",
  puerto_rico = "puerto_rico",
  qatar = "qatar",
  republic_of_congo = "republic_of_congo",
  reunion = "reunion",
  romania = "romania",
  russia = "russia",
  rwanda = "rwanda",
  st_barthelemy = "st_barthelemy",
  st_helena_ascension_tristan_da_cunha = "st_helena_ascension_tristan_da_cunha",
  st_kitts_nevis = "st_kitts_nevis",
  st_lucia = "st_lucia",
  st_martin = "st_martin",
  st_pierre_miquelon = "st_pierre_miquelon",
  st_vincent_grenadines = "st_vincent_grenadines",
  samoa = "samoa",
  san_marino = "san_marino",
  sao_tome_principe = "sao_tome_principe",
  saudi_arabia = "saudi_arabia",
  senegal = "senegal",
  serbia = "serbia",
  seychelles = "seychelles",
  sierra_leone = "sierra_leone",
  singapore = "singapore",
  sint_maarten = "sint_maarten",
  slovakia = "slovakia",
  slovenia = "slovenia",
  solomon_islands = "solomon_islands",
  somalia = "somalia",
  south_africa = "south_africa",
  south_georgia = "south_georgia",
  south_korea = "south_korea",
  south_sudan = "south_sudan",
  spain = "spain",
  sri_lanka = "sri_lanka",
  sudan = "sudan",
  suriname = "suriname",
  svalbard_jan_mayen = "svalbard_jan_mayen",
  sweden = "sweden",
  switzerland = "switzerland",
  syria = "syria",
  taiwan = "taiwan",
  tajikistan = "tajikistan",
  tanzania = "tanzania",
  thailand = "thailand",
  timor_leste = "timor_leste",
  togo = "togo",
  tokelau = "tokelau",
  tonga = "tonga",
  trinidad_tobago = "trinidad_tobago",
  tunisia = "tunisia",
  turkey = "turkey",
  turkmenistan = "turkmenistan",
  turks_caicos_islands = "turks_caicos_islands",
  tuvalu = "tuvalu",
  uganda = "uganda",
  ukraine = "ukraine",
  united_arab_emirates = "united_arab_emirates",
  united_kingdom = "united_kingdom",
  united_states = "united_states",
  united_states_minor_outlying_islands = "united_states_minor_outlying_islands",
  united_states_virgin_islands = "united_states_virgin_islands",
  uruguay = "uruguay",
  uzbekistan = "uzbekistan",
  vanuatu = "vanuatu",
  vatican_city = "vatican_city",
  venezuela = "venezuela",
  vietnam = "vietnam",
  wallis_futuna = "wallis_futuna",
  western_sahara = "western_sahara",
  yemen = "yemen",
  zambia = "zambia",
  zimbabw = "zimbabwe",
}

export type CountryKey = `${CountryKeys}` | CountryKeys
